import * as React from "react";

const CheckIcon = ({ width = 21.333, height = 21.333, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M10.3 5.7c-4 4.7-4.1 4.8-6.1 3C1.2 6 .5 8.4 3.1 12c1.3 1.6 2.6 3 3 3 .8 0 9.1-13.1 8.6-13.6-.2-.2-2.2 1.7-4.4 4.3z" />
  </svg>
);

export default CheckIcon;
